import React from 'react';
import { cnBem } from '@carnica/utils';
import { Text } from "../../Text";
import { isSideText } from "../utils";
import styles from "../styles.pcss";
export var cnCellSide = cnBem('cell', styles);
export var CellSide = function CellSide(_ref) {
  var side = _ref.side,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  if (typeof side === 'function') {
    return side(disabled);
  }
  if (isSideText(side)) {
    var title = side.title,
      subTitle = side.subTitle;
    return /*#__PURE__*/React.createElement(React.Fragment, null, title && /*#__PURE__*/React.createElement(Text, {
      className: cnCellSide('text'),
      color: disabled ? 'tertiary' : 'primary',
      tagName: "span",
      variant: "body-small"
    }, title), subTitle && /*#__PURE__*/React.createElement(Text, {
      className: cnCellSide('text'),
      color: disabled ? 'tertiary' : 'secondary',
      tagName: "span",
      variant: "body-small"
    }, subTitle));
  }
  return side;
};